module.exports = __webpack_public_path__ + "static/img/money.50b13504.png";